import { Component, inject } from '@angular/core';
import { AbstractComponent } from '../abstract/abstract.component';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  providers: [],
  template: ''
})
export class ChildComponent extends AbstractComponent {

  private router = inject(Router);

  constructor(){
    super();
  }

  public goTo = (url: string) => {
    this.router.navigate([url])
  }

}
